import { CSSResultGroup, html, PropertyValues } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'
import { ValueFormElement } from 'elements/_shared/formElement.js'
import { classMap } from 'lit/directives/class-map.js'
import { style } from './date-input.style.js'
import { formFieldValidationTypes } from 'elements/form-field/form-field.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


@customElement('cse-date-input')
export class CSEDateInput extends ValueFormElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: String, attribute: 'id' })
  _id = ''

  @property({ type: String })
  name = ''

  @property({ type: String, reflect: true })
  value = ''

  @property({ type: Boolean })
  required = false

  @property({ type: Boolean })
  disabled = false

  @property({ type: String })
  valid: formFieldValidationTypes[number] = 'none'

  @query('input')
  input!: HTMLInputElement

  @property({ type: String, attribute: 'required-text' })
  requiredText?: string

  @property({ type: Boolean })
  override autofocus = false

  private handleChange = () => {
    this.value = this.input.value
    this.emit(this.value)
  }

  override focus() {
    this.input.focus()
  }

  override render() {
    const classes = classMap({
      'cse-date-input': true,
      'disabled': this.disabled,
      [`valid-${this.valid}`]: true,
    })

    return html`
      <input
        class="${classes}"
        type="date"
        id="${this._id}"
        name="${this.name}"
        value="${this.value}"
        ?required="${this.required}"
        ?disabled="${this.disabled}"
        ?autofocus="${this.autofocus}"
        @change="${this.handleChange}"
      />
    `
  }

  protected override updated(changedProperties: PropertyValues) {
    super.updated(changedProperties)

    if (changedProperties.has('value')) {
      this.checkRequired()
    }
  }

  private checkRequired() {
    if (this.required && this.input.value.trim() === '') {
      this.internals.setValidity({
        valueMissing: true
      }, this.requiredText || 'This field is required', this.input)
    } else {
      this.internals.setValidity({})
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-date-input': CSEDateInput
  }
}
